


















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { log } from '@/log'
import { RawTag } from '@/models/api/tags'
import MailMagazineCheckList from '@spa/components/organisms/mail-magazine/MailMagazineCheckList.vue'
import { MailMagazineService } from '@spa/services/mailMagazine'

import { Decorator } from './model'

@Component({
  components: {
    MailMagazineCheckList,
  },
})
export default class MailMagazine extends Vue {
  @Prop({
    default: () => (tag: RawTag) => tag,
  })
  decorator: Decorator

  /**
   * TODO: ApiTagを使うようにする
   */
  magazines: RawTag[] = []

  async created() {
    const mailMagazineState = await this.magazineService.listAsUser({
      with: 'follow',
    })

    mailMagazineState.fold(
      error => this.onError(error),
      (magazines: RawTag[]) => {
        this.magazines = magazines.map(this.decorator)
      }
    )

    this.onChange(this.magazines)
    this.onLoad()
  }

  onMagazineChecked(_checkedIndex: number, _checkedItem: RawTag, updated: RawTag[]) {
    this.magazines = updated

    this.onChange(this.magazines)
  }

  @Emit('error')
  onError(error: Error): void {
    log.error({ error })

    return
  }

  @Emit('load')
  onLoad(): void {
    return
  }

  @Emit('change')
  onChange(_changedMagazines: RawTag[]): void {
    return
  }

  get existMagazine(): boolean {
    return this.magazines.length > 0
  }

  private get magazineService(): MailMagazineService {
    return new MailMagazineService()
  }
}
